import { render, staticRenderFns } from "./SGConfig.vue?vue&type=template&id=54f8e165"
import script from "./SGConfig.vue?vue&type=script&lang=js"
export * from "./SGConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports